var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import mediaQueries from "syf-component-library/const/mediaQueries";
var GraphWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 345px;\n  height: 180px;\n  margin: 0 auto;\n\n  @media ", " {\n    width: 492px;\n    height: 180px;\n  }\n"], ["\n  width: 345px;\n  height: 180px;\n  margin: 0 auto;\n\n  @media ", " {\n    width: 492px;\n    height: 180px;\n  }\n"])), mediaQueries.greaterThanMedium);
export default GraphWrapper;
var templateObject_1;
